import {makeStyles} from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
	label: {
		fontSize: ".75rem!important",
	},
	tooltipContainer: {
		display: "flex",
	},
	infoIcon: {
		marginLeft: ".5rem",
	},
}))

export default useStyles
